import _get from "lodash/get";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Link } from 'gatsby';
import { Row, Col } from '~layout';
import { AssetRenderer, TransitionItem, helpersPropTypes } from '~helpers';
import { typographyPropTypes } from '~typography';
import Main from './Main';
import OrderConfirmation from './OrderConfirmation';
import LogoContainer from './LogoContainer';
import commerceTheme from '../../styles/commerceTheme';

var ThankYou = function ThankYou(_ref) {
  var logoPath = _ref.logoPath,
      title = _ref.title,
      subtitle = _ref.subtitle,
      content = _ref.content,
      viewportHeight = _ref.viewportHeight,
      transitionTimeout = _ref.transitionTimeout,
      transitionType = _ref.transitionType,
      orderConfirmationColor = _ref.orderConfirmationColor;
  var theme = useContext(ThemeContext);

  var logoWidth = _get(theme, 'commerce.thankYou.logo.width', commerceTheme.commerce.thankYou.logo.width);

  return /*#__PURE__*/React.createElement(Main, {
    viewportHeight: viewportHeight
  }, /*#__PURE__*/React.createElement(TransitionItem, {
    inProp: true,
    transitionType: transitionType,
    transitionTimeout: transitionTimeout,
    appear: true
  }, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Col, {
    xxs: 26,
    xs: 22,
    md: 11
  }, /*#__PURE__*/React.createElement(LogoContainer, null, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement(AssetRenderer, {
    assetPath: logoPath,
    assetWidth: logoWidth
  })))), /*#__PURE__*/React.createElement(Col, {
    xxs: 26,
    xs: 22,
    md: 11
  }, /*#__PURE__*/React.createElement(TransitionItem, {
    inProp: true,
    transitionType: transitionType,
    transitionTimeout: transitionTimeout,
    appear: true
  }, /*#__PURE__*/React.createElement(OrderConfirmation, {
    title: title,
    subtitle: subtitle,
    content: content,
    color: orderConfirmationColor
  }))))));
};

ThankYou.defaultProps = {
  logoPath: null,
  title: null,
  subtitle: null,
  viewportHeight: undefined,
  transitionType: 'fadeInFadeOut',
  transitionTimeout: {
    appear: 500,
    enter: 500
  },
  content: undefined
};
export default ThankYou;